import { useScreen } from '@/hooks/useScreen';
import Typography from 'design-system/components/Typography/Typography';
import { twMerge } from 'tailwind-merge';

const LibraryMaterialDetailReadySection = ({
  icon,
  mainTitle = 'Tài liệu đã sẵn sàng',
  subTitle = 'Đọc tài liệu ngay thôi !',
  ...divProps
}: {
  icon?: React.ReactElement;
  mainTitle?: string;
  subTitle?: string;
} & React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
>) => {
  const { isMobile } = useScreen();

  return (
    <div
      {...divProps}
      className={twMerge(
        'flex items-center gap-3 rounded-[10px] bg-Success/Main px-3 py-2 text-Text/Darkbackground/Primary shadow-elevator1',
        divProps.className
      )}
    >
      {icon}
      <div>
        <Typography variant={isMobile ? 'body1' : 'display2'}>
          {mainTitle}
        </Typography>
        <Typography
          variant={isMobile ? 'body3' : 'body4'}
          className="text-Text/Darkbackground/Secondary"
        >
          {subTitle}
        </Typography>
      </div>
    </div>
  );
};

export default LibraryMaterialDetailReadySection;
